import { createAction } from 'typesafe-actions';
import { IPhenologySpecific } from '../../../types/model/phenology/specific';

export default class PhenologySpecificActions {
    public static setLoading = createAction('PHYNOLOGY_SPECIFIC_SET_LOADING', resolve => (loading : boolean) => resolve(loading));
    public static setSpecifics = createAction('PHYNOLOGY_SPECIFICS_SET', resolve => (blocks : Array<IPhenologySpecific>) => resolve(blocks));
}